module.exports = __webpack_public_path__ + "static/media/logo_placescanner.9c515a87.webp";